/* eslint-disable sort-keys */

import React from 'react'
import Action from './action'

const actionColumn = {
  key: 'action',
  render: (site) => {
    const action = <Action site={site} />
    return action
  },
  title: 'Actions',
  width: 150
}

const nameColumn = {
  dataIndex: 'site_name',
  key: 'site_name',
  sorter: (a, b) => a.site_name.localeCompare(b.site_name),
  title: 'Site Name',
  width: 200
}

const logoColumn = {
  dataIndex: 'site_logo',
  key: 'site_logo',
  title: 'Site Logo',
  width: 200
}

const iconColumn = {
  dataIndex: 'site_favicon',
  key: 'site_favicon',
  title: 'Site Favicon',
  width: 200
}

const colourColumn = {
  dataIndex: 'site_primary_colour',
  key: 'site_primary_colour',
  title: 'Primary Colour',
  width: 120
}

const createdColumn = {
  dataIndex: 'created',
  key: 'created',
  sorter: (a, b) => a.created > b.created,
  title: 'Created',
  width: 120
}

const modifiedColumn = {
  dataIndex: 'modified',
  key: 'modified',
  title: 'Modified',
  width: 120
}

export const siteColumns = {
  action: actionColumn,
  site_name: nameColumn,
  site_logo: logoColumn,
  site_favicon: iconColumn,
  site_colour: colourColumn,
  created: createdColumn,
  modified: modifiedColumn
}
